import { getCurrentUser } from "../../common/utils";
import PrestadorPage from "./PrestadorPage";
import NavegadoraPage from "./NavegadoraPage";
import { Spinner } from "react-bootstrap";

const ReportesFarmacoRouter = () => {
  const dados_usuario = getCurrentUser();

  if (!dados_usuario || !dados_usuario.tipo_usuario) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (dados_usuario.tipo_usuario === "prestador") {
    return <PrestadorPage />;
  } else {
    return <NavegadoraPage />;
  }
};

export default ReportesFarmacoRouter;
